import React from 'react';
import Styles from './PartiuGpComoParticipar.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '@/components/organisms/CustomEmblaCarouselHome24';
import { useLayout } from '@/utils/useLayout';

const SIMULAR_URL =
  'https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=partiu-gp-da-inglaterra:como-participar&int_campaign=simular-financiamento';

const passos = [
  {
    titulo: 'Financie seu veículo',
    texto: 'Financie seu carro ou moto com o Santander entre 01/10 e 30/11/2026',
  },
  {
    titulo: 'Confirme sua participação',
    texto:
      'Aceite a promoção na contratação, com nossos parceiros, ou depois na sua Área do Cliente, até 31/12/2026.',
  },
  {
    titulo: 'Pronto! Agora é só torcer!',
    texto: 'Seu contrato gera 1 número da sorte para concorrer à viagem para Silverstone 2027.',
  },
];

function Card({ passo, className }) {
  return (
    <div className={`card ${className || ''}`}>
      <h3 className="card-titulo">{passo.titulo}</h3>
      <p className="card-texto">{passo.texto}</p>
    </div>
  );
}

function PartiuGpComoParticipar() {
  const { width } = useLayout();
  const isDesktop = width >= 992;

  return (
    <section id="partiu-gp-como-participar">
      <ContainerHome24>
        <h2 className="titulo">Como participar</h2>
        <p className="subtitulo">3 passos simples: financiou, confirmou, concorreu.</p>

        {isDesktop ? (
          <div className="cards">
            {passos.map((passo) => (
              <Card passo={passo} key={passo.titulo} />
            ))}
          </div>
        ) : (
          <div className="carrossel">
            <CustomEmblaCarouselHome24>
              {({ className }) =>
                passos.map((passo) => (
                  <Card passo={passo} className={className} key={passo.titulo} />
                ))
              }
            </CustomEmblaCarouselHome24>
          </div>
        )}

        <a href={SIMULAR_URL} target="_blank" rel="noopener" className="cta">
          Simular agora
        </a>
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default PartiuGpComoParticipar;
